import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/flexible/Paginated';
import { Summary, SummaryOptions } from 'models/flexible/Summary';
import type { AdminSummaryShowFields, AdminSummaryShowInclude } from 'services/api/fields';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export const adminSummariesQueryKeys = {
  index: (params?: Record<string, any>) => ['adminSummaries', params] as const,
  show: (id: string) => ['adminSummary', id] as const,
};

const URL = 'admin/ai_jobs/summaries';

export type AdminSummaryIndexParams = BaseIndexQueryParams & {
  target_classname?: string;
  client?: string;
  created_at?: string;
  'clientType.not'?: string;
  'status.not'?: string;
};

export async function adminIndexSummaries<I extends AdminSummaryShowInclude = never>(
  params: AdminSummaryIndexParams,
  signal?: GenericAbortSignal,
  includes?: I[]
): Promise<Paginated<Summary<AdminSummaryShowFields<I>>>> {
  return http
    .get<
      Paginated<SummaryOptions>
    >(URL, { params: { ...params, ...(includes?.length ? { include: includes.join(',') } : {}) }, signal })
    .then((res) => ({
      ...res.data,
      data: res.data.data.map((x) => new Summary(x)),
    })) as Promise<Paginated<Summary<AdminSummaryShowFields<I>>>>;
}

export async function adminShowSummary<I extends AdminSummaryShowInclude = never>(
  id: string,
  signal?: GenericAbortSignal,
  includes?: I[]
): Promise<Summary<AdminSummaryShowFields<I>>> {
  return http
    .get<SummaryOptions>(`${URL}/${id}`, { params: { include: includes?.join(',') }, signal })
    .then((res) => new Summary(res.data)) as Promise<Summary<AdminSummaryShowFields<I>>>;
}
